import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertTag(component) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "eo-tag",
    properties: _objectSpread(_objectSpread({}, props), {}, {
      themeVariant: "elevo"
    })
  };
}
//# sourceMappingURL=convertTag.js.map